var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showStatus)?_c('ds-status',{attrs:{"type":_vm.statusType,"data-qa":"phone-opt-status"}},[_vm._v(" "+_vm._s(_vm.statusText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }